<template>
  <div class="widget-attachment-regular-layout">
    <div class="widget-attachment-regular-layout__image">
      <img
        v-if="previewUrl"
        class="widget-attachment-regular-layout__preview"
        :src="previewUrl"
      />
      <widget-file-mime-icon
        v-else
        class="widget-attachment-regular-layout__icon"
        :mime-type="mimeType"
      />
    </div>

    <div class="widget-attachment-regular-layout__content">
      <widget-attachment-full-name :name="name" />

      <div class="widget-attachment-regular-layout__details">
        <slot name="details">
          {{ sizeLabel }}
        </slot>
        <slot name="message-info-compensator" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import WidgetFileMimeIcon from '@widgets/shared/components/WidgetFileMimeIcon.vue'
import WidgetAttachmentFullName from '@widgets/shared/components/attachment/WidgetAttachmentFullName.vue'
import { getFileSizeLabel } from '@/utils/file/getFileSizeLabel'
import { computed } from '@/composition/vue/compositionApi'

const { mimeType, name, size, previewUrl } = defineProps<{
  mimeType: string // application/pdf
  name: string // file.pdf
  size: number // in bytes
  previewUrl?: string
}>()

const sizeLabel = computed(() => getFileSizeLabel(size))
</script>

<style lang="scss" scoped>
@import '@/styles/custom-variables';

.widget-attachment-regular-layout {
  display: flex;
  gap: 8px;
  align-items: center;
  color: $neutral;
  font-weight: $regular-font;

  &__image {
    flex-shrink: 0;
    flex-grow: 0;
    line-height: 0;
  }

  &__icon,
  &__preview {
    width: 32px;
    height: 32px;
  }

  &__preview {
    object-fit: cover;
    border-radius: $border-radius;
  }

  &__content {
    flex-shrink: 1;
    flex-grow: 1;
    min-width: 0;
  }

  &__details {
    font-size: 12px;
    line-height: 16px;
    color: $distinct;
  }
}
</style>
